<template>
  <div class="v-calendar" ref="anchorRef">
    <date-picker
      v-model="internalDate"
      :masks="masks"
      :popover="{ visibility: 'click' }"
      @popover-will-show="onOpen"
      @popover-will-hide="onClose"
    >
      <template #default="{ togglePopover, inputValue, inputEvents }">
        <div class="v-calendar__input">
          <t-text
            ref="textRef"
            mask="##.##.####"
            :model-value="inputValue"
            :label="label"
            :placeholder="placeholder ?? 'ДД.ММ.ГГГГ'"
            :errors="errors"
            :name="name"
            :required="required"
            v-on="inputEvents"
            @click="togglePopover()"
          />
          <button
            type="button"
            class="v-calendar__icon"
            @click="togglePopover()"
          >
            <img class="icon" src="@images/calendar.svg" v-svg-inline/>
          </button>
        </div>
      </template>
    </date-picker>
  </div>
</template>

<script setup>
import { DatePicker } from "v-calendar"
import { TText } from "@shared/ui"
import { ref, computed, onErrorCaptured } from 'vue'
import 'v-calendar/style.css'

defineProps({
  label: String,
  placeholder: String,
  disabled: Boolean,
  errors: Array,
  required: Boolean,
  name: String,
})

const model = defineModel()
const masks = { input: "DD.MM.YYYY" }
const textRef = ref(null)

const internalDate = computed({
  get() {
    if (!model.value) return null
    const [d, m, y] = String(model.value).split('.')
    if (!d || !m || !y || y.length < 4) return null
    return new Date(+y, +m - 1, +d)
  },
  set(date) {
    if (!date) { model.value = null; return }
    const d = String(date.getDate()).padStart(2, '0')
    const m = String(date.getMonth() + 1).padStart(2, '0')
    model.value = `${d}.${m}.${date.getFullYear()}`
  }
})

const onOpen = () => textRef.value?.focus()
const onClose = () => textRef.value?.blur()

onErrorCaptured((err) => {
  if (err?.message?.includes('dayIndex')) return false
})
</script>